import { DashboardContent } from '@/layouts/dashboard';
import React, { useEffect, useState } from 'react';
import { Loader } from '@/components/custom/loader';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import { ExamsResolutionCardAttempt } from '../exams-resolution/exams-resolution-card-attempt';
import api from '@/services/api';

export function ExamsMetricsUserItemDetails(props) {
  const { id, uri } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [examData, setExamData] = useState([]);

  const getExamData = async () => {
    try {
      setIsLoading(true);
      const { data } = await api.get(`/question_books_users?filter[current_user]=true&filter[question_book_id]=${id}`);
      setExamData(data);
    } catch (error) {
      console.error('Error fetching exam data:', error);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getExamData();
  }, []);

  const breadcrumbs = {
    title: 'Ferramentas de Avaliação',
    nav: [
      {
        route: '/avaliacoes/meus-resultados',
        name: 'Meus Resultados',
        isActive: false
      },
      {
        route: uri,
        name: examData[0]?.attributes?.['question-book']?.title || 'Detalhes da Avaliação',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <Table className="min-w-[500px]">
          <TableBody>
            {examData.map((item, index) => (
              <TableRow>
                <TableCell className="mb-4 !border-0 !p-0 !shadow-none">
                  <ExamsResolutionCardAttempt
                    key={item.id || index}
                    index={index + 1}
                    attemptData={item.attributes}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </DashboardContent>
  );
}
